let ShopSuey = {
  noScroll(active = true) {
    const body = document.querySelector("body");
    if (active) {
      body.classList.add("no-scroll");
    } else {
      body.classList.remove("no-scroll");
    }
  },
  fetchConfig(type = "json") {
    return {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: `application/${type}`,
      },
    };
  },
  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector).innerHTML;
  },
  setCSSVariable(variable, value) {
    document.documentElement.style.setProperty(variable, value);
  },
  getCSSVariable(variable) {
    getComputedStyle(document.documentElement).getPropertyValue(variable);
  },
};

window.ShopSuey = ShopSuey;
